import { useQuery } from 'react-query';

import getImageToBase64 from '@/common/api/users/files/getImageToBase64';
import { ENDPOINT_FILES_AVATAR } from '@/common/constants';

const useUserFilesAvatar = () =>
  useQuery([ENDPOINT_FILES_AVATAR], getImageToBase64);

export default useUserFilesAvatar;
